import { render, staticRenderFns } from "./ContractorForm.vue?vue&type=template&id=20fd2012&"
import script from "./ContractorForm.vue?vue&type=script&lang=js&"
export * from "./ContractorForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports